import { createContext } from 'react';
import { NoStoreContext } from './no-store.js';
const defineListenerContext = createContext(NoStoreContext);
const LoadedListenersContext = createContext(null);
const IsEnabledContext = createContext(false);
export { IsEnabledContext, LoadedListenersContext, defineListenerContext };
//# sourceMappingURL=context.js.map
